import dynamic from 'next/dynamic';
const ContentfulTextEditor = dynamic(() => import('./ContentfulTextEditor'));
export default ContentfulTextEditor;
